import React from 'react';
import PropTypes from 'prop-types';
// import { Redirect } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  
  static get propTypes() { 
    return { 
        children: PropTypes.any, 
    }; 
  }
  
  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    console.log('error', error)
    console.log('info', info)
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, info);
  }

  render() {
    if (this.state.hasError) {

      window.location.replace("/404")
      
      // You can render any custom fallback UI
      return (
        <div>
          {/* Something is wrong here! */}
          {/* <Redirect to='/404'/> */}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
